<ds-promo-badge
  tone="green"
  iconSrc="/assets/icons/graph.svg"
  iconAlt="graph"
  label="Most Popular"
/>
